import React, { ReactElement } from 'react';
import classNames from 'classnames';
import './RequiresPermission.pcss';
import { useSelector } from 'react-redux';
import { ConnectPageWarning } from './ConnectPageWarning/ConnectPageWarning';
import { hasConnectedRealFacebookPageSelector } from '@mm/state/selectors/userSelector';
import { PrimaryToolTip } from '../../common/components/PrimaryToolTip/PrimaryToolTip';
import { useResolutionInfo } from '@mm/hooks';

interface Props {
  className?: string;
  guardIf?: boolean;
  children: (isAllowed: boolean) => ReactElement;
  classNameArrow?: string;
  classNameContent?: string;
  position?: 'top' | 'bottom' | 'right';
}

export const TooltipGuard = ({
  className,
  children,
  classNameArrow,
  classNameContent,
  position,
  guardIf,
}: Props) => {
  const isUserPageConnected = useSelector(hasConnectedRealFacebookPageSelector);
  const { isDesktop } = useResolutionInfo();

  if (guardIf === false) return children(true);

  const pass: boolean = isUserPageConnected;
  if (pass) return children(pass);

  let content;
  if (!isUserPageConnected) content = <ConnectPageWarning />;

  return (
    <PrimaryToolTip
      type="warning"
      useHover={isDesktop}
      position={position}
      align={isDesktop ? 'center' : 'start'}
      classNameArrow={classNameArrow}
      classNameContent={classNameContent}
      anchorElement={
        <div className={classNames(className, 'requires-permission--disabled')}>
          {children(pass)}
        </div>
      }
    >
      {content}
    </PrimaryToolTip>
  );
};
